/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserInfoVo
 */
export interface UserInfoVo {
    /**
     * 用户id
     * @type {number}
     * @memberof UserInfoVo
     */
    id?: number;
    /**
     * 登录账号
     * @type {string}
     * @memberof UserInfoVo
     */
    account?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof UserInfoVo
     */
    code?: string;
    /**
     * 用户姓名 韩文
     * @type {string}
     * @memberof UserInfoVo
     */
    name?: string;
    /**
     * 用户姓名 英文
     * @type {string}
     * @memberof UserInfoVo
     */
    nameEn?: string;
    /**
     * 电话号码
     * @type {string}
     * @memberof UserInfoVo
     */
    mobileNo?: string;
    /**
     * 电子邮箱
     * @type {string}
     * @memberof UserInfoVo
     */
    email?: string;
    /**
     * 客户商业类型  1 企业 2 个人
     * @type {number}
     * @memberof UserInfoVo
     */
    businessType?: number;
    /**
     * 钱包充值货币类型  目前只有韩币和人民币两种
     * @type {string}
     * @memberof UserInfoVo
     */
    walletCurrencyCode?: string;
    /**
     * 透支额度,即所谓的保证金
     * @type {number}
     * @memberof UserInfoVo
     */
    overdraftLimit?: number;
    /**
     * 是否显示赠送金流水画面 0 隐藏，1 显示
     * @type {number}
     * @memberof UserInfoVo
     */
    showCompensationMenu?: number;
}

/**
 * Check if a given object implements the UserInfoVo interface.
 */
export function instanceOfUserInfoVo(value: object): value is UserInfoVo {
    return true;
}

export function UserInfoVoFromJSON(json: any): UserInfoVo {
    return UserInfoVoFromJSONTyped(json, false);
}

export function UserInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account': json['account'] == null ? undefined : json['account'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'email': json['email'] == null ? undefined : json['email'],
        'businessType': json['businessType'] == null ? undefined : json['businessType'],
        'walletCurrencyCode': json['walletCurrencyCode'] == null ? undefined : json['walletCurrencyCode'],
        'overdraftLimit': json['overdraftLimit'] == null ? undefined : json['overdraftLimit'],
        'showCompensationMenu': json['showCompensationMenu'] == null ? undefined : json['showCompensationMenu'],
    };
}

export function UserInfoVoToJSON(json: any): UserInfoVo {
    return UserInfoVoToJSONTyped(json, false);
}

export function UserInfoVoToJSONTyped(value?: UserInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account': value['account'],
        'code': value['code'],
        'name': value['name'],
        'nameEn': value['nameEn'],
        'mobileNo': value['mobileNo'],
        'email': value['email'],
        'businessType': value['businessType'],
        'walletCurrencyCode': value['walletCurrencyCode'],
        'overdraftLimit': value['overdraftLimit'],
        'showCompensationMenu': value['showCompensationMenu'],
    };
}

